<script setup>
import Block from "@components/redesign/Block/Block.vue";
import SVGIcon from "@components/SVGIcon.vue";
import Spot from "@components/Spot/Spot.vue";
import CircleButton from "@components/redesign/CircleButton/CircleButton.vue";

const animationList = [
  "Preventative",
  "Proactive",
  "Ai-driven",
  "Predictive",
  "Regenerative",
  "Ways2Well",
];
</script>

<template>
  <Block size="extended">
    <div class="home-page-header">
      <SVGIcon class="logo" name="union-logo" />

      <Spot
        width="163"
        height="153"
        top="50"
        right="125"
        rotate="90"
        color="magenta"
        blur="75"
        opacity="1"
        z="-2"
        mobile
      />
      <Spot
        width="222"
        height="208"
        top="0"
        right="0"
        blur="93"
        opacity="1"
        mobile
      />

      <Spot
        width="391"
        height="368"
        top="156"
        right="145"
        color="magenta"
        blur="105"
        opacity="0.4"
        desktop
      />
      <Spot top="0" right="-200" z="-2" desktop />

      <header>
        <h1 class="heading-text">
          The Future of Healthcare is

          <span class="animation">
            <span class="list">
              <span
                v-for="item in animationList"
                :key="item"
                class="heading-text text-brand"
              >
                {{ item }}
              </span>
            </span>
          </span>
        </h1>

        <p class="r-body-regular-to-large">
          Ways2Well pairs powerful bloodwork analysis with expert care
          <br class="hidden-mobile" />
          and personalized protocols to help you reach peak health.
        </p>
      </header>

      <router-link
        class="get-started-button"
        to="/get-started"
        aria-label="get started"
      >
        <circle-button
          class="hidden-mobile"
          label="Get Started"
          url="/get-started"
        />
        <button
          class="button primary hidden-tablet hidden-desktop"
          type="button"
        >
          Get Started
          <SVGIcon name="arrow-right" height="20" width="20" />
        </button>
      </router-link>
    </div>
  </Block>
</template>

<style src="./style.scss" lang="scss" scoped></style>
